import {
  getStats,
  generateSalesforceReauthUrl, getApiUsage
} from "@/services/api/app/salesforce/stats";

const defaultState = () => ({
  stats: {},
  sidebarCollapsed: true,
  apiUsage: {
    apiRequestsLast24h: 0,
    apiRequestsLimit: 15000
  },
});

export default {
  namespaced: true,

  actions: {
    getStats({commit}, data) {
      return getStats(data)
        .then(stats => {
          commit('setStats', stats);
          return stats;
        })
    },
    getApiUsage({ commit }) {
      return getApiUsage()
        .then((res) => {
          const limit = res.Max
          const remaining = res?.Remaining
          const used = limit - remaining

          commit("setApiUsage", {
            apiRequestsLast24h: used,
            apiRequestsLimit: limit || 15000
          });

          return { apiRequestsLast24h: used, apiRequestsLimit: limit };
        })
        .catch((err) => {
          commit("setApiUsage", {
            apiRequestsLast24h: 0,
            apiRequestsLimit: 15000
          });
          return {};
        });
    },
    getReconnectUrl({commit}) {
      const testtt = generateSalesforceReauthUrl();

      console.log('testtt', testtt);
      return testtt;
    },

    toggleSidebar({ commit }) {
      commit('toggleSidebar');
    },
    setSidebar({ commit }, flag) {
      commit('setSidebarCollapsed', flag);
    }
  },

  mutations: {
    setStats(state, stats) {
      state.stats = stats
    },
    setSidebarCollapsed(state, flag) {
      state.sidebarCollapsed = flag;
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setApiUsage(state, apiUsage) {
      state.apiUsage = {
        apiRequestsLast24h: apiUsage.apiRequestsLast24h ?? 0,
        apiRequestsLimit: apiUsage.apiRequestsLimit ?? 15000
      };
    },
  },

  getters: {
    getTotalProtectedData: (state) => () => {
      const
        driveStats = state.stats?.driveStats?.totalData || 0,
        contactStats = state.stats?.contactStats?.totalData || 0,
        googleMailStats = state.stats?.googleMailStats?.totalData || 0,
        calendarStats = state.stats?.calendarStats?.totalData || 0,
        googleSharedDriveStats = state.stats?.googleSharedDriveStats?.totalData || 0,

        totalData = driveStats + contactStats + googleMailStats + calendarStats + googleSharedDriveStats

      return totalData
    },
    isSidebarCollapsed: (state) => state.sidebarCollapsed,
    getApiUsage: (state) => state.apiUsage
  },

  state: defaultState(),
}
